import { useEffect } from 'react'
import { trackExperimentViewed } from '@mc/track-event'
import { PEN_7367_FLAG } from './constants'

export const useTrackPen7367Experiment = () => {
  useEffect(() => {
    trackExperimentViewed(PEN_7367_FLAG)
  }, [])
}
